export const removeLoadingSkeleton = (): void => {
  if (document.getElementById('skeleton-loading-component')) {
    document.getElementById('skeleton-loading-component').remove()
  }
}
